export const OIL_FREE_PISTON_COMPRESSOR_SHM_TYPE = 'Oil free piston compressor';
export const OIL_FREE_PISTON_COMPRESSOR_SHM_TITLE = 'oilFreePistionCompressor';
export const PISTON_COMPRESSOR_SHM_TYPE = 'Piston compressor';
export const PISTON_COMPRESSOR_SHM_TITLE = 'pistonCompressor';
export const OIL_FREE_SCREW_COMPRESSOR_SHM_TYPE = 'Oil free screw compressor';
export const OIL_FREE_SCREW_COMPRESSOR_SHM_TITLE = 'oilFreeScrewCompressor';
export const SCREW_COMPRESSOR_SHM_TYPE = 'Screw compressor';
export const SCREW_COMPRESSOR_SHM_TITLE = 'screwCompressor';
export const DRYER_SHM_TYPE = 'Dryer';
export const DRYER_SHM_TITLE = 'dryer';
export const FILTER_AND_ABSORBER_SHM_TYPE = 'Filter and Adsorber';
export const FILTER_AND_ABSORBER_SHM_TITLE = 'filterAndAdsorber';
export const ACCESSORIES_SHM_TYPE = 'Accessories';
export const ACCESSORIES_SHM_TITLE = 'accessories';
export const RECEIVER_SHM_TYPE = 'Receiver';
export const RECEIVER_SHM_TITLE = 'receiver';
export const CONTAINER_SHM_TYPE = 'Container';
export const CONTAINER_SHM_TITLE = 'container';
export const COMPONENT_SHM_TITLE = 'component';
export const COMPONENT_SHM_TYPE = 'Unrefurbished components';
export const CRAFTSMAN_COMPRESSOR_TYPE = 'Craftsman compressors';
export const CRAFTSMAN_COMPRESSOR_TITLE = 'craftsmanCompressors';
export const SCROLL_COMPRESSOR_TYPE = 'Oil free scroll compressor';
export const SCROLL_COMPRESSOR_TITLE = 'scrollCompressor';

export const TABLE_HEADER_ITEM_SHM_OUTPUT = 'shmThOutput';
export const TABLE_HEADER_ITEM_SHM_MOTOR = 'shmThMotor';
export const TABLE_HEADER_ITEM_SHM_PRESSURE = 'shmThPressure';
export const TABLE_HEADER_ITEM_SHM_TYPE = 'shmThType';
export const TABLE_HEADER_ITEM_SHM_PRICE = 'shmThRetailPrice';
export const TABLE_HEADER_ITEM_SHM_CATEGORY = 'shmThCategory';

export const SORT_KEY_OUTPUT = 'Output';
export const SORT_KEY_MOTOR = 'Motor';
export const SORT_KEY_PRESSURE = 'Pressure';
export const SORT_KEY_SERIES = 'Series';
export const SORT_KEY_SALES_PRICE = 'Sales Price';

export const SHM_DETAIL_PAGE_DE_LINK = '/gebraucht-mietmaschinen/gebraucht-mietmaschinen-im-detail/';
export const SHM_DETAIL_PAGE_EN_LINK = '/second-hand-machines/second-hand-machines-in-detail/';
export const SHM_DETAIL_PAGE_ES_LINK = '/maquinas-usadas/informacion-detallada-maquinas-usadas/';
export const SHM_DETAIL_PAGE_FR_LINK = '/machines-d-occasion/description-detaillee-machines-d-occasion/';
